import { AxiosResponse } from "axios";
import api from "../apiService";
import { ReportQuery } from "./../queries.d";

export const getTotalsReport = async (): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.get("dashboard-report/total");
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});

export const getReport = async (
	type: string,
	query: ReportQuery,
): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.get(
				`dashboard-report/${type}`,
				query,
			);
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});
